import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import $ from "jquery";
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/font/iconfont.css'
import './assets/font/iconfont.js'
import './assets/font/icon.css'
Vue.config.productionTip = false
// Vue.use($)
router.beforeEach((to,from,next)=>{
  document.body.scrollTop=0;
  document.documentElement.scrollTop=0;
  next();
})
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
